import { actions } from '@/store/module/scheduler/action/actions.js';
import { mutations } from '@/store/module/scheduler/mutation/mutations.js';

export const scheduler = {
	namespaced: true,

	state: () => ({
		event: {},
		isFormOpen: false
	}),

	actions,
	mutations
};
